<div *ngIf="!(loadingSubject | async) else loading"
     class="my-profile">

        <ng-container *ngIf="isOpenBadgesActive">
            <app-open-badges-list [badges]="userOpenBadges"
                                  (badgeClick)="showOpenBadgeDialog($event)">
            </app-open-badges-list>
        </ng-container>

        <section *ngIf="userAchievements.length"
                 class="my-profile__achievements">
            <h2 class="my-profile__achievement-title">{{ 'my_profile.achievements_header' | translate }}</h2>
            <ul class="my-profile__achievement-list">
                <li *ngFor="let achievement of userAchievements"
                    class="my-profile__achievement-card"
                    [class.my-profile__achievement-card--locked]="!achievement.attributes.unLocked"
                    [style.background-image]="achievement.attributes.unLocked ? 'url(' + achievement?.get('image') + ')' : null"
                    [matTooltip]="achievement?.get('name')"
                    (click)="openAchievementDialog(achievement.attributes)">
                    <mat-icon *ngIf="!achievement.attributes.unLocked"
                              class="my-profile__locked-achievement-icon"
                              svgIcon="lock-rounded-fill">
                    </mat-icon>
                </li>
            </ul>
        </section>

</div>

<ng-template #loading>

    <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
    </div>

</ng-template>